import React from 'react';
import _ from 'lodash';
import { Box, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const SummaryInsuredInformation = ({ insuredInformation }: any) => {
  const classes = useStyles();

  if (!insuredInformation) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <Box className={classes.subHeader}>
        <Typography className={classes.subHeaderTitle}>
          Updated Insured Information
        </Typography>
      </Box>
      <>
        <Grid
          container
          spacing={6}
          className={classes.AI}
          justifyContent="space-between"
        >
          <Grid item md={2}>
            Insured Information
          </Grid>
          <Grid
            item
            md={10}
            container
            spacing={6}
            style={{ paddingLeft: '3rem' }}
          >
            <Grid item md={3}>
              <Grid>Organization Name:</Grid>
              <Grid style={{ padding: '1rem 0' }}>Address:</Grid>
            </Grid>
            <Grid item md={5}>
              <Grid>
                {insuredInformation.businessName || insuredInformation.name}
              </Grid>
              <Grid style={{ padding: '1rem 0' }}>
                {_.join(
                  [
                    [
                      insuredInformation.address1,
                      insuredInformation.address2,
                    ].join(' '),
                    [insuredInformation.city],
                    [insuredInformation.state, insuredInformation.zipCode].join(
                      ' '
                    ),
                  ],
                  ', '
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </>
    </Grid>
  );
};

const useStyles = makeStyles(({ palette, config }) => ({
  AiDivider: {
    marginTop: '1em',
    marginBottom: '1em',
  },
  AI: {
    fontWeight: 'normal',
    padding: '0 2rem',
    fontSize: config.textSizes.primer,
    color: palette.primary.contrastText,
  },
  subHeader: {
    display: 'flex',
    padding: '0.5em 2em',
    backgroundColor: palette.background.customTable,
    borderRadius: 5,
    lineHeight: 1.4,
    marginBottom: '1.66rem',
  },
  subHeaderTitle: {
    color: palette.primary.contrastText,
    fontSize: config.textSizes.paragon,
    fontWeight: 'normal',
    lineHeight: 1.4,
  },
}));

export default SummaryInsuredInformation;
